export interface UnityConfig {
    loaderUrl: string;
    dataUrl: string;
    frameworkUrl: string;
    codeUrl: string;
}

/**
 * The four Unity build files for the selected game, or null when there are none. gameAssets is
 * wiped on logout, so going back to /app/game after signing in again leaves nothing to read, and a
 * partial config would only fail later inside the loader.
 */
export const unityConfigFrom = (gameAssets: unknown): UnityConfig | null => {
    const files = (gameAssets as any)?.game?.gameFiles;
    if (!files) return null;

    const { loader, data, framework, wasm } = files;
    if (!loader || !data || !framework || !wasm) return null;

    return {
        loaderUrl: loader,
        dataUrl: data,
        frameworkUrl: framework,
        codeUrl: wasm,
    };
};
